import Keyword from './Keyword';

export default class ArrayKeyword extends Keyword {}